export function getEbookFilename(title: string) {
    // Characters not allowed in filenames
    const forbiddenChars = /[<>:"/\\|?*]/g;
    return title.replace(forbiddenChars, "");
}
